import EditEventsSkeleton from './EditEventsPage'
import DefaultTableSkeleton from './DefaultTable'
import ManagementEventsSkeleton from './ManagementEventsPage'
import TableSkeleton from './TableSkeleton'
import TemplateFormContentSkeleton from './TemplateFormContentSkeleton'
import TemplateFormHeaderSkeleton from './TemplateFormHeaderSkeleton'

export const Skeletons = {
  TemplateFormContent: TemplateFormContentSkeleton,
  TemplateFormHeader: TemplateFormHeaderSkeleton,
  Table: TableSkeleton,
  EditEvent: EditEventsSkeleton,
  ManagementEvents: ManagementEventsSkeleton,
  DefaultTable: DefaultTableSkeleton,
}
